var PRD = PRD || {};
! function (t, e) {
    var n = {};
    t.init = function () {
        n.carousel = e(".js-subscription-addons-carousel")
    }, t.initSlider = function () {
        n.carousel.slick({
            initialSlide: 1,
            slidesToShow: 3,
            centerMode: !0,
            infinite: !1,
            dots: !1,
            arrows: !0,
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            }]
        })
    }
}(window.AddonsCarousel = window.AddonsCarousel || {}, jQuery),
function (t, e) {
    window.onpopstate = function (event) {
      console.log(
        "location: " +
          document.location +
          ", state: " +
          JSON.stringify(event.state)
      );
    };
    var n = {},
        i = window.matchMedia("(max-width: 768px)"),
        o = Boolean(e("#gift-a-box").length > 0),
        r = {},
        a = {},
        c = {},
        s = {},
        selling_plans = {},
        d = function (t) {
           
            var i = n.funnelPages.filter(":visible"),
                o = n.funnelPages.filter('[data-step="' + t + '"]'),
                r = n.funnelNavItems.filter('[data-step="' + t + '"]');
            if (!i.is(o)) {
                $(".progress_bar_step").removeClass("active");
                 $(".subscription_back").css('display', 'none');
                if (t > 1) {
                         $("#subscription_back_" + t).css('display', 'flex');
                }
              

                $(".current_subscription_step").text(t);
                $(".current_subscription_step").attr('data-step', t);
                window.currentStep = t;
                    for (t_count = 1; t_count <= t; t_count++) {
                        $("#progress_bar_step_" + t_count).addClass("active");
                    }
                if (t != 3) {
                     $(".step_3_continue_bar").hide();
                 }
                try {
                    //var a = r.find("a").text().toLowerCase().split(" ")[1].replace(" ", "-"),
                    var a = '#subscription_step=' + t,
                        c = window.location.pathname + a;
                    ga("send", "pageview", c)
                } catch (t) {
                    console.error("Unable to send google page view")
                }
                i.fadeOut(function () {
                    console.log({ o });
                    e("html, body").animate({
                        scrollTop: 0
                    }), o.fadeIn()
                     if (t == 3) {
                       document.dispatchEvent(
                         new CustomEvent("step_change", { detail: t })
                       );
                     }
                })

                 
                
                
            }
        },
        u = function (t, e, n) {
            c = {
                id: t,
                selling_plan: e,
                price: n
            }, f(t), d(2)
        },
        l = function (t, e, n) {
            a = e, c = {
                id: "",
                selling_plan: "",
                price: n
            }, f(t), g(), d(2)
        },
        f = function (t) {
            n.activeReview = n.reviewSummaries.filter('[data-product="' + t + '"]'), n.reviewSummaries.removeClass("active"), n.activeReview.addClass("active")
        },
        m = function (t, e) {
            s = {
                shipping_interval_frequency: t,
                shipping_interval_unit_type: e,
                selling_plan: c.selling_plan
            }, h(), d(3)
        },
        p = function (t, e) {
            var n = a["giftId" + t];
            c.id = r[n].first_variant, c.selling_plan = r[n].selling_plan, s = {
                shipping_interval_frequency: 1,
                shipping_interval_unit_type: e,
                selling_plan: c.selling_plan,
                duration: t
            }, w(), d(3)
        },
        v = function () {
            j(), d(4)
        },
        h = function () {
            var t = "Delivered every " + s.shipping_interval_frequency + "-" + s.shipping_interval_unit_type;
            1 === s.shipping_interval_frequency && (t = t.slice(0, -1)), e(".js-review-frequency").text(t)
        },
        g = function () {
            e(".js-gift-duration-price").each(function () {
                var t = e(this),
                    n = c.price * t.data("duration");
                t.text("$" + n + ".00")
            })
        },
        w = function () {
    var t = c.price * s.duration,
        displayMonths = s.duration;
    
    // Convert the duration to the new display values
    if (displayMonths == 3) {
        displayMonths = 4;
    } else if (displayMonths == 6) {
        displayMonths = 8;
    } else if (displayMonths == 9) {
        displayMonths = 12;
    }
    
    // Set the delivery text with the new month count
    var n = "Delivered for " + displayMonths + " " + s.shipping_interval_unit_type;
    e(".js-review-frequency").text(n);
    
    // Modified code for box count display
    var boxCount = s.duration;
    var bonusText = "";
    
    // Add the appropriate bonus text based on duration
    if (boxCount == 3) {
        bonusText = "<span style='color: red;'>+1 month free</span>";
    } else if (boxCount == 6) {
        bonusText = "<span style='color: red;'>+2 months free</span>";
    } else if (boxCount == 9) {
        bonusText = "<span style='color: red;'>+3 months free</span>";
    }
    
    // Set the text with HTML for the colored bonus
    e(".js-review-box-count").html("x " + boxCount + " " + bonusText);
    
    e(".js-review-box-price, .js-review-total-price").text("$" + t);
},

        y = function (t) {
            var e = {
                updates: {}
            };
            return _.forEach(t, function (t, i) {
                Boolean(n.addonAtc.filter('[data-product="' + t.id + '"]').length) && (e.updates[t.id] = 0)
            }), S(e).then(function (t) {
                b(t.items), Promise.resolve()
            })
        },
        b = function (t) {
            if (t.length >= 1 && window.currentStep == 3) {
              $(".step_3_continue_bar").show();
            }
            n.addonAtc.removeClass("in-cart"), _.forEach(t, function (t, e) {
                var i = n.addonAtc.filter('[data-product="' + t.id + '"]');
                t.quantity > 0 ? (i.find(".js-addon-atc-quantity").text(t.quantity), i.data("line-item", e + 1), i.addClass("in-cart")) : i.removeClass("in-cart")
            }), n.activeReview && j()
        },
        j = function () {
            var t = n.activeReview.find(".js-review-addons-price"),
                i = parseInt(t.data("box-price"), 10),
                o = 0;
            n.addonAtc.filter(".in-cart").each(function (t, n) {
                var i = e(n),
                    r = parseInt(i.find(".js-addon-atc-quantity").text(), 10),
                    a = parseInt(i.data("price"));
                o += r * a
            }), t.text("$" + o), n.activeReview.find(".js-review-total-price").text("$" + (o + i))
        },
        P = function () {
            return new Promise(function (t, e) {
                C(c.id, 1, s.selling_plan, true, s, selling_plans).then(function () {
                    return t()
                })
            })
        },
        k = function (t, e) {
            var n = {
                shipping_interval_frequency: s.shipping_interval_frequency,
                shipping_interval_unit_type: s.shipping_interval_unit_type,
                selling_plan: e
            };
            //n = null;
            n = {
                note: '1 time delivery'
            };
            C(t, 1, n, undefined, undefined, false).then(function () {
                return T()
            }).then(function (t) {
                b(t.items)
            })
        },
        x = function (t, e) {
            var i = n.addonAtc.filter('[data-product="' + t + '"]'),
                o = parseInt(i.find(".js-addon-atc-quantity").text(), 10),
                r = e ? o + 1 : Math.max(o - 1, 0);
            I(i.data("line-item"), r).then(function (t) {
                return b(t.items)
            })
        },
        T = function () {
            return new Promise(function (t, e) {
                RC.cart.get(function (e) {
                    return t(e)
                })
            })
        },
        C = function (t, e, n, selling_plan, s, selling_plans_local) {
            return new Promise(function (i, o) {
                let selling_plan_id = n;
                if (selling_plans_local) {
                    const selling_plans = selling_plans_local.split(',');
                    switch (s.shipping_interval_frequency) {
                        case 2:
                            selling_plan_id = selling_plans[2];
                            break;
                        case 4:
                            selling_plan_id = selling_plans[1];
                            break;
                        case 8:
                            selling_plan_id = selling_plans[0];
                            break;
                    }
                }
                if (selling_plan) {
                    RC.cart.add({
                        id: t,
                        quantity: e,
                        selling_plan: selling_plan_id
                    }, function () {
                        return i()
                    })
                } else {
                    RC.cart.add({
                        id: t,
                        quantity: e,
                        properties: n
                    }, function () {
                        return i()
                    })
                }
            })
        },
        I = function (t, e) {
            return new Promise(function (n, i) {
                RC.cart.change({
                    line: t,
                    quantity: e
                }, function (t) {
                    return n(t)
                })
            })
        },
        S = function (t) {
            return new Promise(function (e, n) {
                RC.cart.update(t, function (t) {
                    return e(t)
                })
            })
        };
    t.init = function (t) {
        console.log('init', t);
        window.currentStep = 1;
        r = t, n.funnelNavItems = e(".js-funnel-nav"), n.funnelPages = e(".js-funnel-page"), n.navigateToStep = e(".js-navigate-to-funnel-step"), n.productCards = e(".js-funnel-product-card"), n.selectBox = e(".js-select-box"), n.modalTrigger = e(".js-subscription-card-info"), n.frequencySelector = e(".js-select-frequency"), n.durationSelector = e(".js-select-duration"), n.addonAtc = e(".js-addon-atc"), n.addonContinue = e(".js-addon-continue"), n.addonRemoveAll = e(".js-addon-remove-all"), n.reviewSummaries = e(".js-review-summary-list").children(), n.activeReview = null, n.completeFunnel = e(".js-complete-funnel"), n.funnelPages.filter('[data-step="1"]').fadeIn(), n.navigateToStep.click(function (t) {
            var n = e(t.currentTarget),
                i = parseInt(e(".js-funnel-nav.active").data("step"), 10),
                o = parseInt(n.data("step"), 10);
            i = window.currentStep;
            t.preventDefault(), i > o && d(o)
        }), n.modalTrigger.click(function (t) {
            return t.stopPropagation()
        }), n.productCards.click(function (t) {
            var n = e(t.currentTarget);
            t.preventDefault(), i.matches && Modal.open(n.data("open"))
        }), n.selectBox.click(function (t) {
            var n = e(t.currentTarget),
                i = (n.data("selling-plan"), {
                    giftId3: n.data("gift-three"),
                    giftId6: n.data("gift-six"),
                    giftId9: n.data("gift-nine")
                });
            selling_plans = n.data('selling-plans');
            o ? l(n.data("product"), i, parseInt(n.data("price"), 10)) : u(n.data("product"), n.data("selling-plan"), parseInt(n.data("price"), 10))
        }), n.frequencySelector.click(function (t) {
            var n = e(t.currentTarget);
            t.preventDefault(), m(n.data("frequency"), n.data("unit-type"))
        }), n.durationSelector.click(function (t) {
            var n = e(t.currentTarget);
            t.preventDefault(), p(n.data("duration"), n.data("unit-type"))
        }), n.addonAtc.on("click", ".js-addon-atc-add", function (t) {
            var n = e(t.delegateTarget);
           // k(n.data("product"), n.data("subscription-id"))
           k(n.data("product"), null); 
        }), n.addonAtc.on("click", ".js-addon-atc-increment", function (t) {
            var n = e(t.delegateTarget);
            x(n.data("product"), !0)
        }), n.addonAtc.on("click", ".js-addon-atc-decrement", function (t) {
            var n = e(t.delegateTarget);
            x(n.data("product"), !1)
        }), n.addonContinue.on("click", function () {
            return v()
        }), n.addonRemoveAll.on("click", function () {
            T().then(function (t) {
                return y(t.items)
            }).then(function () {
                v()
            })
        }), n.completeFunnel.click(function (t) {
            e(t.currentTarget).attr("disabled", "true"), P().then(function () {
                return window.location.href = "/cart"
            })
        }), T().then(function (t) {
            return b(t.items)
        })
    }
}(window.CustomFunnel = window.CustomFunnel || {}, jQuery),
function (t, e) {
    t.init = function () {
        window.addEventListener("klaviyoForms", function (t) {
            "open" == t.detail.type && ga("send", "event", "Klaviyo form", "form_open", t.detail.formId), "submit" == t.detail.type && ga("send", "event", "Klaviyo form", "form_submit", t.detail.formId)
        }), e(".js-learn-more").on("click", function () {
            return ga("send", "pageview", "/learn-more")
        })
    }
}(window.GAEvents = window.GAEvents || {}, jQuery),
function (t, e) {
    var n = {};
    t.init = function () {
        n.productItems = e(".product-listing__item"), n.productItems.on("click", function (t) {
            var n = e(t.target);
            (n.hasClass("waitlist-toggle") || n.hasClass("add-to-cart")) && t.preventDefault()
        })
    }
}(window.GridItem = window.GridItem || {}, jQuery),
function (t, e) {
    var n = {};
    t.init = function () {
        n.slider = e(".js-instagram-carousel"), n.slider.slick({
            centerMode: !0,
            slidesToShow: 1,
            arrows: !1,
            dots: !1,
            mobileFirst: !0,
            swipeToSlide: !0,
            responsive: [{
                breakpoint: 480,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3
                }
            }, {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4
                }
            }, {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 5
                }
            }]
        })
    }
}(window.InstagramCarousel = window.InstagramCarousel || {}, jQuery),
function (t, e) {
    "use strict";
    var n = {},
        i = 0;
    t.open = function (t) {
        var o = e('[data-modal="' + t + '"]');
        document.querySelector('[data-modal="' + t + '"]');
        n.body.attr("data-active-modal", t), o.fadeIn(300, function () {
            return o.trigger("modal-opened")
        }).addClass("show"), i = window.pageYOffset, n.body.css("top", "-" + window.pageYOffset + "px"), n.html.addClass("is--locked")
    }, t.close = function (t) {
        var o = e('[data-modal="' + t + '"]'),
            r = o.find(".video-container");
        r.length && r.children("iframe")[0].contentWindow.postMessage('{"event": "command", "func": "pauseVideo", "args":""}', "*"), n.body.removeAttr("data-active-modal"), o.fadeOut(300, function () {
            return o.trigger("modal-closed").removeClass("show")
        }), n.body.css("top", ""), n.html.removeClass("is--locked"), window.scrollTo(0, i)
    };
    t.init = function () {
        n.html = e("html"), n.body = e("body"), n.modal = e("[data-modal]"), n.modalShow = e("[data-open-modal]"), n.modalHide = e("[data-close-modal]"), n.modalShow.on("click", function (t) {
            t.preventDefault(), window.Modal.open(e(this).data("open-modal"))
        }), n.modalHide.on("click", function (t) {
            t.preventDefault(), window.Modal.close(e(this).data("close-modal"))
        })
    }
}(window.Modal = window.Modal || {}, jQuery), PRD.account = function (t, e) {
        return {
            init: function () {
                e(".account--order_listing").on("click", function () {
                    window.location.href = e(this).attr("data-url")
                })
            }
        }
    }(0, jQuery), PRD.backInStock = function (t, e) {
        return {
            init: function () {
                klaviyo.enable("backinstock", {
                    trigger: {
                        replace_sold_out: !0,
                        collection_page_text: "Join the Waitlist",
                        collection_page_class: "button button--white"
                    },
                    modal: {
                        headline: "{product_name}",
                        body_content: "Register to receive a notification when this item comes back in stock.",
                        email_field_label: "Email",
                        button_label: "Notify me when available",
                        subscription_success_label: "You're in! We'll let you know when it's back.",
                        footer_content: "",
                        close_label: "Close",
                        additional_styles: "@import url('https://fonts.googleapis.com/css?family=Helvetica+Neue');",
                        font_family: '"Helvetica Neue", Helvetica, Arial, sans-serif;',
                        drop_background_color: "#000",
                        background_color: "#fff",
                        text_color: "#222",
                        button_text_color: "#fff",
                        button_background_color: "#252525",
                        close_button_color: "#ccc",
                        error_background_color: "#fcd6d7",
                        error_text_color: "#C72E2F",
                        success_background_color: "#d3efcd",
                        success_text_color: "#1B9500"
                    }
                })
            }
        }
    }(0, jQuery), PRD.newsletter = function (t, e) {
        return {
            init: function () {
                KlaviyoSubscribe.attachToForms("#newsletter_signup--form", {
                    hide_form_on_success: !0,
                    extra_properties: {
                        $source: "footer"
                    },
                    success_message: "Thank You. Your special offer will be emailed to you shortly.",
                    success: function (t, n) {
                        e(".newsletter_signup--wrapper").addClass("success")
                    }
                })
            }
        }
    }(0, jQuery),
    function (t, e) {
        var n, i, o, r = {},
            a = _.template(e("#sidecart-itemlist-template").html()),
            c = window.matchMedia("(max-width: 767px)"),
            s = function () {
                var t = r.variantSelect.data("target"),
                    n = r.variantSelect.val();
                e('.js-sidecart-add-item[data-name="' + t + '"]').data("product-id", n)
            },
            d = function (t) {
                var n = t.val();
                e(".js-sidecart-add-item").filter('[data-name="' + t.data("target") + '"]').data("quantity", n)
            },
            u = function (t, n, i) {
                var o = e(".js-sidecart-items").find('[data-product-id="' + t + '"]'),
                    r = _.isInteger(n) ? n : 1;
                o.length > 0 && !i ? (r = parseInt(o.find(".js-sidecart-product-quantity").text(), 10) + r, T(t, r, !0)) : x(t, r, i, !0)
            },
            l = function (t) {
                console.log("@@ decrementProduct");
                var e = t.data("product-id"),
                    n = Math.max(parseInt(t.find(".js-sidecart-product-quantity").text(), 10) - 1, 0),
                    i = t.data("line-index");
                T(e, n, !1, parseInt(i))
            },
            f = function (t) {
                var e = t.data("product-id"),
                    n = parseInt(t.find(".js-sidecart-product-quantity").text(), 10) + 1,
                    i = t.data("line-index");
                T(e, n, !1, parseInt(i))
            },
            m = function (t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                    n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function () {};
                console.log("@@ removeProduct");
                var o = t.data("product-id"),
                    r = t.data("line-index");
                o === i.promoProduct && e && b(), T(o, 0, !1, parseInt(r), n)
            },
            p = function () {
                clearTimeout(n), r.sidecartDrawer.removeClass("open"), r.open.click()
            },
            v = function (t) {
                console.log("@@@ updateSidecartDOM"), k();
                var n = function (t) {
                    var e = (t.total_price / 100).toFixed(2),
                        n = _.find(t.items, function (t) {
                            return t.id === i.promoProduct
                        });
                    return n && (e -= (n.line_price / 100)), e
                }(t);
                console.log("cartData"), console.log(t), r.totalItems.text(t.item_count), r.navTotalItems.text(t.item_count), r.sidecartTotal.text("$" + n), e(".js-sidecart-items").find("[data-line-index]").each(function (n) {
                    var i = e(this),
                        o = i.data("product-id"),
                        r = _.find(t.items, function (t) {
                            return t.id === o
                        }),
                        a = _.findIndex(t.items, function (t) {
                            return t.id === o
                        });
                    r && r.quantity > 0 ? (i.data("line-index", a), i.find(".js-sidecart-product-quantity").text(r.quantity)) : i.fadeOut("fast", function () {
                        return i.remove()
                    })

                    r && r.discounts.length ? (
                        (
                            i.find(".js-discount-msg").text(r.discounts[0].title).fadeIn(300)
                        ) 
                    ) : (
                        (
                            i.find(".js-discount-msg").fadeOut(300, function(el) {
                                $(el).text('');
                                $.getJSON('/products/' + r.handle + '.js', function(ajaxProd) {})                            
                            })
                        )
                    );

                    r && (r.discounted_price !== r.original_price) ? (
                        (
                            i.find('.sidecart__item__controls__price.discounted').length === 0 ? 
                            i.find('.sidecart__item__controls__price').before(
                                $('<p />', {
                                    'class' : 'sidecart__item__controls__price discounted',
                                    'text'  : '$' + (r.discounted_price / 100).toFixed(2)
                                })
                            ) : null
                        )
                    ) : (
                        i.find('.sidecart__item__controls__price.discounted').remove()
                    );

                }), "threshold" === i.promoType && (h(t) ? y(n) : y(0)), t.item_count > 0 ? (r.emptyMessage.hide(), r.itemList.show(), window.setTimeout(function () {
                    e(".js-sidecart-items").find("[data-line-index]").each(function (t) {
                        e(this).attr("data-line-index", t)
                    })
                }, 300)) : (r.emptyMessage.show(), r.itemList.hide())
            },
            h = function (t) {
                console.log("@@ hasNonGiftCardProducts");
                var e = !1,
                    n = _.find(t.items, function (t) {
                        return !0 !== t.gift_card && t.id !== i.promoProduct
                    });
                return n && (console.log("foundOtherItems " + n.title), e = !0), e
            },
            g = function (t) {
                t.sort(function (t, e) {
                    return t.id === i.promoProduct ? -1 : 0
                });
                var e = a({
                    products: t,
                    promoId: i.promoProduct
                });
                r.itemList.html(e)
            },
            w = _.debounce(function (t) {
                m(r.sidecart.find('[data-product-id="' + i.promoProduct + '"]'), !1, t)
            }, 300),
            y = function (t) {
                var e = i.promoThreshold - t,
                    n = r.sidecart.find('[data-product-id="' + i.promoProduct + '"]').length > 0,
                    o = "1" === localStorage.hasRemovedPromoProduct;
                e > 0 ? (n && w(), (n || o) && r.sidecartPromoSuccess.fadeOut("fast", function () {
                    return r.sidecartPromoDetails.fadeIn("fast")
                }), r.sidecartPromoProgress.css("width", t / i.promoThreshold * 100 + "%"), r.sidecartPromoThreshold.text("$" + e)) : n || o ? (o && r.sidecartPromoReadd.show(), r.sidecartPromoDetails.fadeOut("fast", function () {
                    return r.sidecartPromoSuccess.fadeIn("fast")
                })) : (r.sidecartPromoProgress.css("width", "100%"), r.sidecartPromoThreshold.text("$0"), r.sidecartPromoDetails.fadeOut("fast", function () {
                    return r.sidecartPromoSuccess.fadeIn("fast")
                }), u(i.promoProduct, 1))
            },
            b = function () {
                localStorage.hasRemovedPromoProduct = "1"
            },
            j = function () {
                delete localStorage.hasRemovedPromoProduct
            },
            P = function () {
                return "timer" !== i.promoType || moment.duration(o - moment().valueOf()).valueOf() < 0
            },
            k = function () {
                RC.cart.get(function (t) {
                    _.find(t.items, function (t) {
                        return t.id === i.promoProduct
                    }) && !0 && RC.cart.change({
                        id: i.promoProduct,
                        quantity: 1
                    }, function (t) {})
                })
            },
            x = function (t, i, o) {
                var a = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
                    s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null;
                RC.cart.add({
                    id: t,
                    quantity: i,
                    selling_plan: o
                }, function () {
                    RC.cart.get(function (i) {
                        var o = i.items ? _.find(i.items, function (e) {
                            return e.id === t
                        }) : i;
                        g(i.items), v(i), Boolean(a) && function (t) {
                            if (c.matches) {
                                var i = t.image || e('meta[itemprop="image"]').attr("content");
                                r.sidecartDrawerImage.attr("src", i), r.sidecartDrawerTitle.text(t.product_title), r.sidecartDrawer.addClass("open"), n = setTimeout(function () {
                                    r.sidecartDrawer.removeClass("open")
                                }, 5e3)
                            } else r.open.click()
                        }(o), s && s()
                    })
                })
            },
            T = function (t, e) {
                arguments.length > 2 && void 0 !== arguments[2] && arguments[2], arguments[3], arguments[4];
                RC.cart.change({
                    id: t,
                    quantity: e
                }, function (e) {
                    e.items && _.find(e.items, function (e) {
                        return e.id === t
                    });
                    v(e)
                })
            },
            C = function (t) {
                var n = t.items.slice(0),
                    o = _.findIndex(n, function (t) {
                        return t.id == i.promoProduct
                    }) > -1,
                    r = _.filter(n, function (t) {
                        return t.id != i.promoProduct
                    });
                o && r.length < 1 && w(function () {
                    e("body").hasClass("template-cart") && window.location.reload()
                })
            },
            I = function () {
                if ("timer" === i.promoType) {
                    var t = moment(i.promoEnd + " -0500", "M-D-YYYY h:m Z");
                    o = t.valueOf(), moment.duration(o - moment().valueOf()).valueOf() > 0 ? setInterval(function () {
                        return t = o, e = moment().valueOf(), n = moment.duration(t - e), i = Math.floor(n.asDays()), a = n.hours() + "h " + n.minutes() + "m " + n.seconds() + "s", i > 0 && (a = i + "d " + a), void(n.valueOf() > 0 ? r.sidecartPromoTimer.text(a) : r.sidecartPromo.remove());
                        var t, e, n, i, a
                    }, 1e3) : r.sidecartPromo.remove()
                }
            };
        t.init = function (t) {
            i = t, r.body = e("body"), r.sidecart = e(".js-sidecart"), r.sidecartCheckoutBtn = e(".js-sidecart-checkout-btn"), r.open = e(".js-open-sidecart"), r.close = e(".js-close-sidecart"), r.totalItems = e(".js-sidecart-total-items"), r.navTotalItems = e("#minicart-count"), r.emptyMessage = e(".js-sidecart-empty"), r.itemList = e(".js-sidecart-items"), r.variantSelect = e(".js-product-variant-selector"), r.sidecartTotal = e(".js-sidecart-total"), r.quantitySelect = e(".js-product-quantity-selector"), r.sidecartDrawer = e(".js-sidecart-drawer"), r.sidecartDrawerImage = e(".js-sidecart-drawer-image"), r.sidecartDrawerTitle = e(".js-sidecart-drawer-title"), r.openSidecartFromDrawer = e(".js-open-sidecart-from-drawer"), r.sidecartPromo = e(".js-sidecart-promo"), r.sidecartPromoDetails = e(".js-sidecart-promo-details"), r.sidecartPromoSuccess = e(".js-sidecart-promo-success"), r.sidecartPromoReadd = e(".js-sidecart-promo-re-add"), r.sidecartPromoTimer = e(".js-sidecart-promo-timer"), r.sidecartPromoThreshold = e(".js-sidecart-promo-threshold"), r.sidecartPromoProgress = e(".js-sidecart-promo-progress"), r.open.on("click", function () {
                return r.body.addClass("sidecart-open")
            }), r.close.on("click", function () {
                return r.body.removeClass("sidecart-open")
            }), r.openSidecartFromDrawer.on("click", function () {
                return p()
            }), r.quantitySelect.on("change", function (t) {
                return d(e(t.currentTarget))
            }), e(window).on("product-variant-updated", s), e(document).on("click", ".js-sidecart-add-item", function (t) {
                var n = e(t.currentTarget),
                    i = parseInt(n.data("product-id"), 10),
                    o = parseInt(n.data("quantity"), 10),
                    r = n.data("sub-id"),
                    a = n.data("sub-frequency"),
                    c = {};
                t.preventDefault(), e(".rc_widget__option--subsave.rc-option--active").length && (i = parseInt(n.data("product-id"), 10), c =  e(".rc-selling-plans__dropdown").val()), r && (c.shipping_interval_frequency = a, c.shipping_interval_unit_type = "Weeks", c.selling_plan = r), u(i, o, c)
            }), e(document).on("click", ".js-decrement-sidecart-product", function (t) {
                t.preventDefault(), l(e(t.currentTarget).closest("[data-line-index]"))
            }), e(document).on("click", ".js-increment-sidecart-product", function (t) {
                t.preventDefault(), f(e(t.currentTarget).closest("[data-line-index]"))
            }), e(document).on("click", ".js-remove-sidecart-item", function (t) {
                t.preventDefault(), m(e(t.currentTarget).closest("[data-product-id]"), !0)
            }), r.sidecartPromoReadd.on("click", function () {
                j(), r.sidecartPromoReadd.fadeOut("fast"), u(i.promoProduct, 1)
            }), "timer" === i.promoType && r.sidecartCheckoutBtn.on("click", function (t) {
                var n = e(t.currentTarget),
                    o = n.attr("href");
                if (!P() && h()) {
                    var a = r.sidecart.find("[data-line-index]").length > 0;
                    t.preventDefault(), n.attr("disabled", "disabled"), a && i.enablePromo || (window.location.href = o)
                }
            }), RC.cart.get(function (t) {
                g(t.items), v(t), C(t)
            }), i.enablePromo && I()
        }
    }(window.SideCart = window.SideCart || {}, jQuery),
    function (t, e) {
        var n, i = {};
        t.init = function () {
            i.header = e("header"), i.scroller = e(".js-smooth-scroll"), n = i.header.outerHeight(), i.scroller.click(function (t) {
                var i = e(t.currentTarget);
                i.attr("href"), t.preventDefault(), e("html, body").animate({
                    scrollTop: e(i.attr("href")).offset().top - n
                }, 600)
            })
        }
    }(window.SmoothScroll = window.SmoothScroll || {}, jQuery),
    function (t, e) {
        var n = {};
        t.init = function () {
            n.form = e(".sweeps-email-form"), n.input = e(".sweeps-email-form__input-text"), n.button = e(".sweeps-email-form__input-submit"), n.spinner = e(".spinner"), n.message = e(".sweeps-email-form--message"), n.form.on("submit", function (t) {
                email = n.input.val(), n.message.hasClass("hidden") && (email ? (n.spinner.removeClass("hidden"), n.button.addClass("hidden"), setTimeout(function () {
                    n.message.removeClass("hidden"), n.button.removeClass("hidden"), n.spinner.addClass("hidden"), n.button.text(n.button.attr("data-success-message"))
                }, 3e3)) : t.preventDefault())
            }), KlaviyoSubscribe.attachToForms("#email-signup", {
                hide_form_on_success: !1,
                custom_success_message: !0
            })
        }
    }(window.SweepsEmail = window.SweepsEmail || {}, jQuery), PRD.router = function (t, e) {
        return {
            init: function () {
                t.newsletter.init(), t.backInStock.init(), e("body.template-account").length && t.account.init()
            }
        }
    }(PRD, jQuery), PRD.router.init();


    $(function () {
        $('.klaviyo-bis-trigger').click(function (e) {
            const productTitle = $(this).data('product');
            ga("send", "event", "Join Waitlist", "Signup", productTitle);
            return true;
        })
    });